import React, { Component } from "react";

import getAppErrors from "../../../../lib/appErrors";
import Api from "../../../../lib/componentApi";
import validateForm, { formErrorsMessage } from "../../../../lib/validateForm";

import Submit from "../../../../components/Users/Payment/Submit";

import ErrorSection from "../../../../components/Common/AppErrors";
import Loading from "../../../../components/Common/Loading";

class PaymentMethodsSubmit extends Component {
  constructor(props) {
    const {
      holderName,
      expMonth,
      expYear,
      number,
      cvv2
    } = formErrorsMessage.addPayment;
    super(props);
    this.state = {
      holderName: "",
      expYear: "",
      expMonth: "",
      number: "",
      cvv2: "",
      error: null,
      showErrors: false,
      loading: false,
      active: false,
      formErrors: {
        holderName,
        expYear,
        expMonth,
        number,
        cvv2
      }
    };
  }
  handleChange = event => {
    event.preventDefault();
    const input = event.target.id;
    let inputValue = event.target.value;
    if (
      input === "number" &&
      inputValue.length &&
      inputValue.search("_") === -1
    ) {
      inputValue = inputValue.split("-").join("");
    }
    this.setState(
      {
        [input]: inputValue,
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "addPayment");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { holderName, expYear, expMonth, number, cvv2 } = this.state;
          const errors = Object.values(this.state.formErrors).filter(Boolean);
          if (
            holderName &&
            expYear &&
            expMonth &&
            number &&
            cvv2 &&
            !errors.length
          ) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  isValid = () => {
    const { holderName, expYear, expMonth, cvv2, number } = this.state;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    if (holderName && expYear && expMonth && cvv2 && number && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  handleSubmit = event => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { holderName, expYear, expMonth, cvv2, number } = this.state;
      const { handleCloseSection } = this.props;
      this.setState({ loading: true });
      Api.post(
        "/api/payment/add",
        {
          holderName,
          expYear,
          expMonth,
          cvv2,
          number
        },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
            this.setState({ loading: true });
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            this.setState({
              error: (errorMessage && errorMessage.message) || response.message,
              loading: false,
              active: false
            });
          } else {
            handleCloseSection(event, response);
            this.setState({ loading: false });
          }
        }
      );
    }
  };
  onCloseErrorSection = () => {
    this.setState({ error: null });
  };
  render() {
    const {
      holderName,
      expYear,
      expMonth,
      cvv2,
      number,
      error,
      loading,
      formErrors,
      showErrors,
      active
    } = this.state;
    const { handleCloseSection } = this.props;
    return (
      (error && (
        <ErrorSection onClickClose={this.onCloseErrorSection} message={error} />
      )) || (
        <div>
          {(loading && <Loading />) || <noscript />}
          <Submit
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            holderName={holderName}
            expYear={expYear}
            expMonth={expMonth}
            cvv2={cvv2}
            number={number}
            formErrors={formErrors}
            active={active}
            handleCloseSection={handleCloseSection}
            showErrors={showErrors}
          />
        </div>
      )
    );
  }
}

export default PaymentMethodsSubmit;
